module.exports = function getResource(label, vars = []) {
    let resources = {
        selectShoppingExperience: 'Sélectionnez une expérience de magasinage',
        unitedStates: 'États-Unis'
    };
    return resources[label];
};
